<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-800 p-4">
    <div class="text-center">
      <h1 class="text-2xl font-medium text-gray-800 dark:text-gray-200">404</h1>
      <p class="mt-2 text-gray-600 dark:text-gray-400">{{ t('plugin.error.load') }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { t } from '@/i18n'
</script>
